// extracted by mini-css-extract-plugin
export var actions = "style-module--actions--e79fe";
export var blockedText = "style-module--blockedText--85150";
export var certificateUpload = "style-module--certificateUpload--14265";
export var warningText = "style-module--warningText--ad950";